// src/views/GetStarted.jsx
import React, { useState, useEffect } from 'react';
import OnboardingWizard from '../components/OnboardingWizard';

export default function GetStarted() {
  const [referralUsername, setReferralUsername] = useState(null);

  useEffect(() => {
    const referral = new URLSearchParams(window.location.search).get('r');
    if (referral?.trim()) {
      setReferralUsername(referral.trim());
    }
  }, []);

  return (
    <OnboardingWizard variant="page" referralUsername={referralUsername} skipServiceStep={false} />
  );
}
